"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TraitSection = exports.FeedbackType = void 0;
var FeedbackType;
(function (FeedbackType) {
    FeedbackType["interest"] = "interest";
    FeedbackType["accuracy"] = "accuracy";
})(FeedbackType = exports.FeedbackType || (exports.FeedbackType = {}));
var TraitSection;
(function (TraitSection) {
    TraitSection["summary"] = "summary";
    TraitSection["conflict"] = "conflict";
    TraitSection["caution"] = "caution";
    TraitSection["happiness"] = "happiness";
    TraitSection["identity"] = "identity";
    TraitSection["intellect"] = "intellect";
    TraitSection["interests"] = "interests";
    TraitSection["leadership"] = "leadership";
    TraitSection["love"] = "love";
    TraitSection["research"] = "research";
    TraitSection["work"] = "work";
    TraitSection["details"] = "details";
    TraitSection["social"] = "social";
    TraitSection["development"] = "development";
    TraitSection["strength"] = "strength";
    TraitSection["friends"] = "friends";
    TraitSection["manage"] = "manage";
    TraitSection["lowScorers"] = "lowScorers";
    TraitSection["notablePeople"] = "notablePeople";
    TraitSection["advice"] = "advice";
})(TraitSection = exports.TraitSection || (exports.TraitSection = {}));
